import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../components/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { truncateText } from "../../../../utility/helper";
import { currencyOption, dateModeOptions } from "../../../../utility/data";
import FortuneComponent from "./wealthComponent/fortune";
import DetailsComponent from "./wealthComponent/details/index";
import LegacyComponent from "./wealthComponent/legacy/legacy";
import LookForComponent from "./wealthComponent/lookFor";

import {
  getDetailsAssetService,
  getDetailsInnerService,
  getFortuneService,
  getLegacyDataService,
} from "../../../../services/viewWealth";
import moment from "moment";
import {
  fetchGroups,
  resetGroupsState,
} from "../../../../redux/slices/groupsSlice";

const WealthView = () => {
  const [selectedButton, setSelectedButton] = useState("Fortune");
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(0);
  const { createdAt } = useSelector((state) => state.user);
  const [dateMode, setDateMode] = useState("ytd");
  const [dateRange, setDateRange] = useState([
    moment(createdAt || moment().subtract(1, "month")).toDate(),
    moment().toDate(),
  ]);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [leagcyData, setLeagcyData] = useState([]);
  const [fortuneData, setFortuneData] = useState([]);
  const [viewDetails, setViewDetails] = useState([]);
  const [viewInnerDetails, setViewInnerDetails] = useState([]);
  const [graphDetails, setGraphDetails] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { currency } = useSelector((state) => state.user);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const dispatch = useDispatch();
  const { groupsData } = useSelector((state) => state.groups);

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken));
    }
    return () => {
      dispatch(resetGroupsState());
    };
  }, [dispatch, accessToken]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  useEffect(() => {
    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange.map((date) =>
        moment(date).format("YYYY-MM-DD")
      );

      if (startDate && endDate !== "Invalid date") {
        GetWealthFortuneData(dateMode, startDate, endDate);
        GetWealthLegacyData(dateMode, startDate, endDate);
        GetDetailsAssetTableData(dateMode, startDate, endDate);
      }
    }
  }, [dateRange, dateMode]);

  useEffect(() => {
    if (dateRange && dateRange.length === 2 && selectedAsset) {
      const [startDate, endDate] = dateRange.map((date) =>
        moment(date).format("YYYY-MM-DD")
      );

      if (startDate && endDate !== "Invalid date") {
        GetDetailsInnerTableData(dateMode, selectedAsset, startDate, endDate);
      }
    }
  }, [dateRange, selectedAsset, dateMode]);

  useEffect(() => {
    if (selectedButton) {
      setSelectedAsset(null);
      setSelectedDetail(null);
    }
  }, [selectedButton]);

  const GetDetailsAssetTableData = async (type, startDate, endDate) => {
    setLoading(true);
    try {
      const response = await getDetailsAssetService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setViewDetails(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetDetailsInnerTableData = async (
    type,
    selectedAsset,
    startDate,
    endDate
  ) => {
    setLoading(true);
    try {
      const response = await getDetailsInnerService(
        type,
        selectedAsset,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setViewInnerDetails(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const GetWealthLegacyData = async (type, startDate, endDate) => {
    setLoading(true);
    try {
      const response = await getLegacyDataService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setLeagcyData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const GetWealthFortuneData = async (type, startDate, endDate) => {
    setLoading(true);
    try {
      const response = await getFortuneService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setFortuneData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCalendarHide = () => {
    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange;
      if (startDate && !endDate) {
        setViewDetails([]);
        setViewInnerDetails([]);
        setGraphDetails([]);
        setLeagcyData([]);
        setFortuneData([]);
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: "Please select end date",
          life: 3000,
        });
      }
    }
  };

  const selectedDateModeOption = dateModeOptions.find(
    (opt) => opt.value === dateMode
  );

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div
        className={`relative ${
          mediaLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        <div className="md:flex justify-end md:gap-64 md:mr-10">
          <div className="flex gap-4 items-center">
            <CustomDropdown
              options={dateModeOptions}
              name={selectedDateModeOption.name}
              assetId={selectedDateModeOption.value}
              returnFullObject={true}
              onOptionSelect={(item) => setDateMode(item.value)}
              truncateText={truncateText}
              direction={"right"}
              size={19}
              className="inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-md font-medium bg-transparent rounded-md"
            />
            {dateMode === "ytd" && <span className="text-secondary">YTD</span>}

            {dateMode === "range" && (
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value)}
                selectionMode="range"
                onHide={handleCalendarHide}
                dateFormat="dd/mm/yy"
                maxDate={moment().toDate()}
                readOnlyInput
                placeholder="Select date range"
                className="wealth_date w-full"
              />
            )}
          </div>
          <div className="flex gap-4 items-center">
            <span className="text-lightPrimary dark:text-white">Currency</span>
            <CustomDropdown
              options={currencyOption}
              name={currency || "Select Currency"}
              assetId={currency || null}
              returnFullObject={true}
              truncateText={truncateText}
              disabled={true}
              direction={"right"}
              size={19}
              className="text-gray-400 cursor-not-allowed inline-flex whitespace-nowrap justify-center px-1 py-1.5  items-center gap-1 text-md font-medium bg-transparent rounded-md"
            />
          </div>
        </div>
        <div className="pt-3"></div>
        <div className="w-full overflow-x-auto">
          <div className="flex gap-8 item-baseline md:ml-10 overflow-x-auto">
            {[
              "Fortune",
              "Details",
              "Financial Profile",
              "Look for",
              "Legacy",
              "Insider",
            ].map((btn) => (
              <button
                key={btn}
                className={
                  selectedButton === btn
                    ? "text-secondary font-bold text-xl"
                    : "text-info dark:text-white"
                }
                onClick={() => setSelectedButton(btn)}
              >
                {btn}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-5">
          {selectedButton === "Look for" && (
            <LookForComponent fortuneData={fortuneData} />
          )}
          {selectedButton === "Fortune" && (
            <FortuneComponent
              fortuneData={fortuneData}
              groupsData={groupsData}
            />
          )}
          {selectedButton === "Legacy" && (
            <LegacyComponent
              leagcyData={leagcyData}
              handleOptionSelect={"handleOptionSelect"}
              confirmDelete={"confirmDelete"}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
            />
          )}
          {selectedButton === "Details" && (
            <DetailsComponent
              viewDetails={viewDetails}
              viewInnerDetails={viewInnerDetails}
              setSelectedDetail={setSelectedDetail}
              selectedDetail={selectedDetail}
              selectedAsset={selectedAsset}
              graphDetails={graphDetails}
              setSelectedAsset={setSelectedAsset}
              handleOptionSelect={"handleOptionSelect"}
              confirmDelete={"confirmDelete"}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              selectedButton={selectedButton}
              groupsData={groupsData}
            />
          )}
        </div>
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner />
        </div>
      )}
    </>
  );
};

export default WealthView;
